export default "__VITE_ASSET__BfqA59G5__"